export enum PaymentRequestApiType {
  ApplePay = 1 ,
  MicrosoftPay = 2,
  GooglePay = 3,
  Other = 0
}
